import React from "react";

import { Button } from "@mui/material";
import settings_svg from "../../assets/settings.svg";
import { useAppDispatch } from "../../hooks/reduxhook";
import { addsettingModal } from "../../redux/slices/settingSlice";

const SettingsButton = () => {
  const dispatch = useAppDispatch();
  return (
    <Button
      data-testid="setting-button"
      id="settingsbutton"
      variant="contained"
      color="primary"
      startIcon={<img src={settings_svg} width="15px" color="white" />}
      sx={{
        margin: "20px auto",
        width: "90%",
      }}
      onClick={() => {
        dispatch(addsettingModal(true));
      }}
    >
      Settings
    </Button>
  );
};

export default SettingsButton;
